import { Navigate, useParams } from "react-router-dom";

export default function UniversityReportsIndexPage() {
  const { universityId } = useParams();
  return <Navigate to={`/education/universities/${universityId}/reports/semester`} replace />;
}
